import React, { FC, useState, useEffect, ReactElement } from 'react';
import Paging from 'src/components/atoms/Paging/Default';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import Parse from 'html-react-parser';
import { addComma } from 'src/utils/common';
import _ from 'lodash';
import './style.scss';
import { useLocation } from 'react-router-dom';

interface Props {
  gridOption: any;
  rowClickEvt?: (id: string) => void;
  deleteDocEvt?: () => void;
  dataType?: string;
  noContentStyleDef?: React.CSSProperties;
  noContentText?: string;
  viewType?: string;
  deleteBtnStatus?: string;
  pageInfo?: { current: number; totalCount: number; size: number; viewCount: number };
  pagingClick?: (num: number) => void;
  sortClickEvt?: (item: any) => void;
}

const TableGridBox: FC<Props> = ({
  gridOption,
  rowClickEvt,
  deleteDocEvt,
  deleteBtnStatus = 'none',
  pageInfo,
  pagingClick,
  dataType,
  noContentStyleDef,
  noContentText = 'No Content',
  viewType,
  sortClickEvt,
}) => {
  const { state } = useLocation();
  const [sortValue, setSortValue] = useState({ col: '', status: 'desc' });

  const pageClick = (num: number) => {
    pagingClick !== undefined && pagingClick(num);
  };
  const orgData = _.cloneDeep(gridOption.data) || [];
  const styleDef = gridOption.styleDef || {};
  const rowStyleDef = gridOption.rowStyleDef || {};
  // Event
  const sortClickEvent = (item: any) => {
    const useYn = item.sort?.use || false;
    if (sortClickEvt && useYn) {
      const retSort = { col: item.col, status: item.sort?.status };

      const reSortStatus = sortValue.status === 'desc' ? 'asc' : 'desc';
      retSort.status = reSortStatus;
      setSortValue({ col: item.col, status: reSortStatus });

      sortClickEvt(retSort);
    }
  };
  const rowClickEvent = (param: any) => {
    rowClickEvt !== undefined && rowClickEvt(param);
  };

  const setGridData = () => {
    const setData: any = [];
    orgData.forEach((itemRow: any, idx: number) => {
      const rowData = [];
      for (const itemCol of gridOption.label) {
        const customObj = itemCol.custom || null;
        let cusElement = null;
        if (customObj !== null) {
          const setObj: any = [];
          for (const param of customObj.param) {
            setObj.push(itemRow[param]);
          }
          //
          cusElement = customObj.fn(setObj, customObj.static);
        }
        const col = itemRow[itemCol.col] || '';
        rowData.push({ key: itemCol.col, value: col, custom: cusElement });
      }
      setData.push({ row: rowData });
    });
    gridOption.data = setData;
  };
  setGridData();

  const deleteDocEvent = () => {
    if (deleteDocEvt) deleteDocEvt();
  };

  const customValue = (value: any, option: any) => {
    return <>{value}</>;
  };
  const rowValue = (value: any, option: any) => {
    if (option.dom) {
      return <>{Parse(value)}</>;
    } else {
      return <>{value}</>;
    }
  };

  const drawContent = () => {
    return (
      <React.Fragment>
        {gridOption.data.map(
          (
            item: { row: { key: string; value: string; custom: ReactElement | null }[] },
            idx: number
          ) => {
            const retObj: any = {};
            item.row.forEach((item: any) => {
              retObj[item.key] = item.value;
            });

            return (
              <div
                className="_row"
                key={'_' + idx}
                onClick={e => rowClickEvent(retObj)}
                style={{ ...rowStyleDef }}
              >
                {item.row.map((row: { key: string; value: string; custom: any }, i: number) => {
                  let align = 'center';
                  let textAlign = 'middle';

                  if (gridOption.label[i].align === 'left') {
                    align = 'flex-start';
                    textAlign = 'left';
                  }
                  if (gridOption.label[i].align === 'right') {
                    align = 'flex-end';
                    textAlign = 'right';
                  }

                  let topAlign = 'center';
                  if (gridOption.label[i].topAlign === 'top') {
                    topAlign = 'flex-start';
                  }
                  const useYN: string = gridOption.label[i].useYN || '';
                  if (useYN !== 'none') {
                    return (
                      <div
                        className="_col _ft_ct_t1"
                        style={{
                          ...gridOption.label[i].style,
                          width: gridOption.label[i].width,
                          justifyContent: align,
                          alignItems: topAlign,
                          textAlign: textAlign,
                        }}
                        key={idx + '_' + i}
                      >
                        {useYN === '' ? (
                          <div className="_text">
                            {row.custom !== null
                              ? customValue(row.custom, gridOption.label[i])
                              : rowValue(row.value || '', gridOption.label[i])}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    );
                    return '';
                  }
                })}
              </div>
            );
          }
        )}
      </React.Fragment>
    );
  };
  const noContent = () => {
    return (
      <div className="_no_result" style={noContentStyleDef}>
        <div className="_label _ft_lb_t3">{noContentText}</div>
      </div>
    );
  };
  return (
    <div className="_grid_table_layout_comp">
      <div className="_count_div">
        {pageInfo ? (
          <>
            <div className="_label _ft_lb_t1">전체</div>
            <div className="_count">
              {addComma(gridOption.totalCount || 0)}
              <em>건</em>
            </div>
          </>
        ) : (
          ''
        )}

        {deleteBtnStatus !== 'none' ? (
          <div className="_btn_div">
            <div className="_btn ">
              <DefaultButton
                text="삭제"
                styleDef={{ height: '34px', width: '110px', minWidth: '50px' }}
                clickEvent={e => deleteDocEvent()}
                icon="ri-delete-bin-6-line"
                status={deleteBtnStatus}
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="_grid_layout">
        <div className={['_grid_box scroll_style', viewType].join(' ')}>
          <div className={['_grid'].join(' ')} style={{ ...styleDef }}>
            <div className="_row_content _label">
              <div className="_row _label _ft_lb_t1">
                {gridOption.label.map((item: any, idx: number) => {
                  let align = 'center';
                  if (item.align === 'left') {
                    align = 'flex-start';
                  }
                  if (item.align === 'right') align = 'flex-end';

                  if (item.labelAlign) {
                    if (item.labelAlign === 'left') {
                      align = 'flex-start';
                    }
                    if (item.labelAlign === 'center') {
                      align = 'center';
                    }
                    if (item.labelAlign === 'right') align = 'flex-end';
                  }

                  const sort = item.sort || {};
                  const useYN: string = item.useYN || '';
                  let sortStatus = sort.status || 'desc';
                  if (sortValue.col === item.col) {
                    sortStatus = sortValue.status;
                  }
                  const sortLabel = sortStatus === 'desc' ? '_desc' : '_asc';
                  if (useYN !== 'none') {
                    return (
                      <div
                        className={sort?.use ? '_col _cursor' : '_col'}
                        style={{ width: item.width, justifyContent: align }}
                        key={idx + '_'}
                        onClick={e => sortClickEvent(item)}
                      >
                        <div className="_tit _ft_lb_t1">{item.label}</div>
                        {sort?.use ? <div className={['_btn', sortLabel].join(' ')} /> : ''}
                      </div>
                    );
                  }
                  return '';
                })}
              </div>
            </div>
            <div className="_row_content">
              {gridOption.data.length > 0 ? drawContent() : noContent()}
            </div>
          </div>
        </div>
        {gridOption.data.length > 0 && pageInfo ? (
          <div className="_paging_div">
            <Paging
              currentPage={pageInfo?.current || 1}
              totalCount={pageInfo.totalCount}
              rowSize={pageInfo?.viewCount || 10}
              viewPageSize={pageInfo?.size || 5}
              onChangePage={pageClick}
            />
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default TableGridBox;
